<template>
    <div
        class="skeleton"
        :style="{
            width: width,
            height: height,
            borderRadius: borderRadius
        }"
    ></div>
</template>

<script>
export default {
    name: 'Skeleton',
    props: {
        /**
         * Width of the skeleton element
         * Can be any valid CSS width value (px, %, etc)
         */
        width: {
            type: String,
            default: '100%'
        },
        /**
         * Height of the skeleton element
         * Can be any valid CSS height value (px, %, etc)
         */
        height: {
            type: String,
            default: '20px'
        },
        /**
         * Border radius of the skeleton element
         * Can be any valid CSS border-radius value
         */
        borderRadius: {
            type: String,
            default: '4px'
        }
    }
};
</script>

<style scoped lang="scss">
.skeleton {
    background: linear-gradient(
        90deg,
        rgba(190, 190, 190, 0.2) 25%,
        rgba(129, 129, 129, 0.24) 37%,
        rgba(190, 190, 190, 0.2) 63%
    );
    background-size: 400% 100%;
    animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
    0% {
        background-position: 100% 50%;
    }
    100% {
        background-position: 0 50%;
    }
}
</style>
